<template>
  <!--
    Code By     : 陈伦刚
    CreateTime  : 2020-12-14 09:52:16
    Description : 封面上传组件
  -->
  <div class="upload-cover">
    <el-image
      :style="{ width: width, height: height }"
      :src="cover ? imageBaseUrl + cover : ''"
      fit="cover"
    >
      <div slot="error" class="image-slot">
        <i class="el-icon-picture-outline"></i>
      </div>
    </el-image>
    <el-upload
      v-if='showUpload'
      ref="upload"
      action=""
      accept="image/jpeg,image/png,image/bmp"
      :limit="1"
      :multiple="false"
      :show-file-list="false"
      :file-list="fileList"
      :before-upload="beforeUpload"
      :http-request="upload"
    >
      <el-button type="primary" size="small">
        {{ cover === "" ? title : "重新上传" }}
      </el-button>
    </el-upload>
    <el-dialog
      top="30vh"
      width="300px"
      title="上传中"
      :visible.sync="visible"
      :show-close="false"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-progress :percentage="progress"></el-progress>
    </el-dialog>
  </div>
</template>

<script>
import OSS from "ali-oss";
import { uploadCover } from "@/api/upload";
export default {
  name: "upload-cover",
  props: {
    src: {
      type: String,
      default: "",
    },
    title: {
      type: String,
      default: "上传封面",
    },
    width: {
      type: String,
      default: "183px",
    },
    height: {
      type: String,
      default: "100px",
    },
    showUpload: {
      type: Boolean,
      default: true,
    }
  },
  watch: {
    src(src) {
      this.cover = src;
    },
  },
  data() {
    return {
      imageBaseUrl: process.env.VUE_APP_RESOURCES_URL,
      fileList: [],
      cover: "",
      visible: false,
      progress: 0,
    };
  },
  methods: {
    beforeUpload(file) {
      if (["image/jpeg", "image/png", "image/bmp"].indexOf(file.type) == -1) {
        this.$message.error("请选择正确的图像格式");
        return false;
      }
      if (!(file.size / 1024 / 1024 < 5)) {
        this.$message.error("请上传5M以内的图片");
        return false;
      }
      return true;
    },
    upload(file) {
      this.fileList = [];
      this.progress = 0;
      this.visible = true;
      const name = file.file.name;
      const data = {
        fileFormat: name.split(".")[name.split(".").length - 1],
        sts: true,
        type: "cover",
      };
      uploadCover(data)
        .then(({ uploadToken }) => {
          const fileName = uploadToken.dir + uploadToken.fileName;
          const ossConfig = {
            region: "oss-cn-hangzhou",
            accessKeyId: uploadToken.accessKeyId,
            accessKeySecret: uploadToken.accessKeySecret,
            stsToken: uploadToken.signature,
            bucket: uploadToken.bucket,
          };
          const client = new OSS(ossConfig);
          client
            .multipartUpload(fileName, file.file, {
              progress: (p) => {
                this.progress = parseInt(p * 100);
              },
            })
            .then(
              (res) => {
                this.visible = false;
                if (this.title === "上传封面") {
                  this.$message.success("封面上传成功");
                }
                this.cover = fileName;
                this.$emit("change", this.cover);
              },
              (err) => {
                this.visible = false;
                this.$message.error("oss上传失败");
                console.log("err", err);
              }
            );
        })
        .catch((res) => {
          console.log(res);
          this.$message.error("上传接口调用失败");
          this.visible = false;
        });
    },
  },
};
</script>

<style lang="less">
.upload-cover {
  display: flex;
  align-items: flex-end;
  .el-image {
    display: inline-block;
    width: 183px;
    height: 100px;
    margin-right: 10px;
    background-color: #f2f2f2;
    .image-slot {
      text-align: center;
      line-height: 100px;
      font-size: 30px;
      color: #c0c4cc;
    }
  }

  .el-button {
    height: 32px;
  }

  .el-dialog__body {
    padding-top: 0;
  }

  .vue-cropper {
    width: 480px;
    height: 253px;
  }
}
</style>
